var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('router-link',{attrs:{"to":{ name: 'artist-detail', params: { slug: _vm.slug } }}},[_c('img',{staticClass:"column rounded",attrs:{"src":_vm.mediaUrl + '/' + _vm.photo}})]),_c('v-card-text',[_c('strong',[_vm._v(_vm._s(_vm.name))]),_c('br'),_vm._v(" "+_vm._s(_vm.job)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }